import React, {Suspense} from "react";
import { NavLink } from "react-router-dom";
import {useTranslation} from "react-i18next";

function HeaderComponent()
{
  const {t} = useTranslation('translation');
    return <footer>
		<p><NavLink to="impressum_datenschutz" component="Impressum">{t('footer.impress')}</NavLink></p>
		<p>Copyright 2023 – Notensatzstudio Veeser</p>
	</footer>
}

function Footer() {
  return (
    <Suspense fallback="loading">
            <div className="App">
                <HeaderComponent/>
            </div>
        </Suspense>
  );
}

export default Footer;
